/**
* 修改enjs文件后，应将修改或新增的自动同步到zh.js
* zh.js 和 en.js 字段数量应一致，如不熟悉字段使用范围，应尽量新增字段，避免修改现有字段
* **/
export default {
	common:{
		viewDetails:'View details',
		viewAll:'View all'
	},
	nav:{
		home:'Home',
		about:'About Us',
		hxxt:'Hua Xin Academy',
		whzq:'Lanting Culture Zone​ ',
		bjd:'Baduanjin Promotion Program',
		yxl:'Community & Social Impact',
		news:'News',
		contact:'Contact Us'
	},
	
	footer:{
		backTop:'Back top',
		officeAddress:'Office address',
		adText1:'Please feel free to contact us at any time.',
		adText2:'Provide higher-quality and more socially valuable services for global Chinese people.',
		contactInfo:'Contact information: ',
		websiteAddress:'Website address: ',
		companyName:'Huaxin Culture (Singapore) Private Limited'
	},
	home:{
		bannerAd1:'Preserve Chinese culture · Embrace the intelligent future',
		aboutAd1:'Inspire the future through education',
		aboutAd2:'Connecting the world through culture',
		aboutAd3:'With charity, warmth the community',
		aboutAd4:'Become an influential platform for education, culture, health and social innovation on an international scale',
		aboutAd4:'Become an influential platform for education, culture, health and social innovation on an international scale',
		aboutAd5:'<p>Huaxin Culture is an educational, cultural and social innovation institution based in Singapore and oriented towards international development.</p>"Huaxin" symbolizes the integration of Chinese culture and the spirit of Singapore.',
		aboutAd6:'We base ourselves on Chinese culture and emphasize diversity and integration. We aim to promote lifelong learning, cultural understanding, physical and mental health, and community integration through the development of four major areas: education, culture, health, and social influence. Our goal is to help people of all age groups improve their quality of life and enhance their future competitiveness.',
		aboutAd7:'Three major curriculum systems',
		
		
		schoolItem1Title:'Global Reading Ability Development System',
		schoolItem1Text:'Develop reading skills, critical thinking abilities, communication skills, a global perspective and the ability for lifelong learning.',
		schoolItem1SonTitle:'English Original Reading Center',
		schoolItem1Tag1:'Reading ability',
		schoolItem1Tag2:'Writing ability',
		schoolItem1Tag3:'Critical thinking',
		schoolItem1Tag4:'Oral presentation skills',
		
		schoolItem2Title:'Chinese classic reading system',
		schoolItem2Text:'Cultivate cultural confidence, character cultivation, historical wisdom, literary literacy and leadership skills.',
		schoolItem2SonTitle:'Chinese Classic Reading Center',     
		schoolItem2Tag1:'The Analects',
		schoolItem2Tag2:'Mencius',
		schoolItem2Tag3:'The Great Learning',
		schoolItem2Tag4:'The Doctrine of the Mean',
		schoolItem2Tag5:'Classic of Poetry',
		
		schoolItem3Title:'Future education system',
		schoolItem3Text:'Developing AI literacy, digital citizenship awareness, future adaptability and innovation capabilities.',
		schoolItem3SonTitle:'Future education center',
		schoolItem3Tag1:'Teenager courses',
		schoolItem3Tag2:'Parent courses',
		schoolItem3Tag3:'Elderly courses',
		
		
		block1Ad1:'Public welfare',
		block1Ad2:'Community charity plan',
		block1Tag1:'Digital mentor training',
		block1Tag2:'Community volunteers',
		block1Tag3:'Youth leaders​',
		block1Tag4:'Welfare ambassadors​',
		block1Text:'The company and its founder, Ms. Feng Tingting, have long been involved in community welfare activities in Singapore. They support community development, lifelong education, and digital inclusion through continuous donations and public welfare cooperation projects.',
		block2Ad1:'Lanting Culture',
		block2Ad2:'Through cultural exchanges, cultural experience activities, international cooperation projects and the cultivation of cultural ambassadors, we aim to help people from different backgrounds understand the traditional Chinese culture and appreciate the humanistic values carried by Chinese civilization.',
		
		newsUpdates:'News Updates'
		
	},
	about:{
		fixNav1:'About Us',
		fixNav2:'Our Founder',
		fixNav3:'Founder\'s Note',
		
		 
		
		company:'Company profile',
		aboutText1:'<div class="aboutBoxTitle"><p>Huaxin Culture is an educational, cultural and social innovation institution based in Singapore and oriented towards international development.</p><p>"Huaxin" symbolizes the integration of Chinese culture and the spirit of Singapore.</p></div><div class="aboutBoxText">We base ourselves on Chinese culture and pursue a principle of diversity and integration. We aim to promote lifelong learning, cultural understanding, physical and mental health, and community integration through the development of four major areas: education, culture, health, and social influence. We strive to help people of all age groups enhance their quality of life and future competitiveness. We believe:<br/>Education enlightens the future<br/>Culture connects the world<br/>Health promotes happiness<br/>Charity warms the community<br/>Through cross-disciplinary cooperation and social innovation, we will create a learning platform with an international perspective, humanistic care, and social responsibility.</div>',
		
		vision:'Vision',
		visionText:'To be a globally influential platform for education, culture, health, and social innovation. We connect cultural roots, foster civilizational exchange, and cultivate future global citizens.',
		
		mission:'Mission',
		missionText:'To nurture future citizens with a global perspective, cultural confidence, healthy lifestyles, and a strong sense of social responsibility.',
		
		values:'Values',
		valuesText:'Lifelong Learning<br/>Cultural Heritage<br/>Holistic Health<br/>Social Care<br/>Pioneering Innovation',
		
		ceoAbout:'Founder introduction',
		
		aboutFounder:'<div class="aboutBoxTitle">About the Founder</div>'+
				'<div class="aboutBoxText">'+
					'<p>Ms. Feng Tingting is the founder of Huaxin Culture (Singapore) Pte. Ltd., dedicated to education, cultural exchange, international cooperation, and community welfare.</p>'+
					'<p>Recognizing Singapore\'s multicultural society and her love for Chinese culture, she founded Huaxin Culture in 2025. The company aims to be a vital bridge connecting China and the world, fostering educational exchange, cultural mutual learning, and community integration.</p>'+
					'<p>She believes culture unites nations and ethnic groups, education transforms individual and family futures, and philanthropy makes society warmer and more inclusive.</p>'+
				'</div>'+
				'<br />'+
				'<div class="aboutBoxTitle">'+
					'Entrepreneurial Philosophy'+
				'</div>'+
				'<div class="aboutBoxText">'+
					'<p>In today\'s rapid globalization, more Chinese families seek international educational resources while preserving their cultural roots and integrating into their resident countries.</p>'+
					'<p>Founded on Singapore\'s excellent education system and multicultural environment, Huaxin Culture is a comprehensive platform integrating education, culture, welfare, and technology. It provides premium, socially valuable services for local residents and the global Chinese community.</p>'+
				'</div>'+
				'<br />'+
				'<div class="aboutBoxTitle">'+
					'Social Responsibility'+
				'</div>'+
				'<div class="aboutBoxText">'+
					'<p>Ms. Feng firmly believes that business growth should pursue commercial value while undertaking social responsibility.</p>'+
					'<p>She actively supports Singapore\'s community welfare and leads Huaxin Culture in promoting digital literacy for seniors, AI, and healthy living concepts. They aim to help residents share the benefits of the digital age through education and technology.</p>'+
					'<p>In the future, the company will use AI-driven content to promote traditional Chinese wellness culture (e.g., Baduanjin, Tai Chi, Sinology classics), spreading healthy lifestyles and excellent traditional culture in Singapore.</p>'+
				'</div>'+
				'<br />'+
				'<div class="aboutBoxTitle">'+
					'Future Vision'+
				'</div>'+
				'<div class="aboutBoxText">'+
					'<p>Ms. Feng envisions Huaxin Culture as:</p>'+
					'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>A key bridge for educational and cultural exchange between Singapore and China;</div>'+
					'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>A platform for promoting bilingual education and Chinese culture;</div>'+
					'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>A public welfare enterprise serving communities and enhancing social cohesion;</div>'+
					'<div class="aboutBoxTextList"><i class="iconfont icon-gou1"></i>An innovative practitioner using AI to spread health education and traditional culture.</div>'+
				'</div>'+
				'<br />'+
				'<div class="aboutBoxTitle">'+
					'Her Belief：'+
				'</div>'+
				'<div class="aboutBoxText">'+
					'Education connects to the future, culture connects the world, and welfare connects hearts.'+
				'</div>',
		
	},
	school:{
		ad1:'The education brand under Huaxin Culture',
		ad2:'Discover the World · Master Chinese · Look to the Future',
		sonTitle:'Three major curriculum systems'
	},
	special:{
		sonTitle:'Six core projects',
		aboutText:'Mission:​ Fostering cultural understanding and civilizational exchange. <br/>We connect diverse communities through events, exchanges, and ambassador initiatives—unlocking the heritage of Chinese culture and its enduring humanistic values.',
		
		item1Title:'Overseas Communication Base',
		item1SonTitle:'Showcasing Lanting to the World',
		item1Text:'Serving as a hub for Lanting\'s international communication, a center for Sino-foreign calligraphy exchange, and a benchmark for Chinese culture going global. We open up all channels for Lanting\'s overseas dissemination, making Lanting brushwork a core symbol for the world to understand the elegance of Chinese culture.',
		
		item2Title:'Lanting Gathering',
		item2SonTitle:'A Grand Feast of Guofeng Culture, Bridging Ancient and Modern',
		item2Text:'Replicating the timeless artistic conception of the Yonghe Elegant Gathering. We create a top-tier Guofeng cultural IP that is normalized, refined, and immersive; inheriting the elegance of literati and revitalizing traditional literati aesthetics.',
		
		item3Title:'Lanting Youth Program',
		item3SonTitle:'Cultivating New Forces for Cultural Heritage',
		item3Text:'A systematic program for inheriting and cultivating Lanting culture among youth. We focus on calligraphy aesthetic education for children, sowing seeds of traditional culture and nurturing inheritors of the Lanting legacy in the new era.',
		
		item4Title:'Lanting Family Program',
		item4SonTitle:'Cultural Scenes for Community Enjoyment',
		item4Text:'A lightweight, accessible, and regular cultural experience for all. We bring Lanting culture into families and daily life, making traditional culture a shared experience for everyone.',
		
		item5Title:'Lanting International Exhibition',
		item5SonTitle:'An Art Hub for Cross-disciplinary Fusion',
		item5Text:'An international, open, and innovative platform for calligraphy. We gather global artistic forces to create the benchmark Lanting art exhibition IP.',
		
		item6Title:'Lanting International Study Tour',
		item6SonTitle:'Cultural Study Tours: Bridging Theory and Practice',
		item6Text:'An international, boutique, and systematic study tour brand. We are building China\'s premier, world-class destination for Lanting calligraphy and cultural study tours.'
	},
	promotion:{
		sonTitle:'Four major sectors',
		sonTitle2:'8 minutes a day, make health a habit',
		ad1:'Promoting Traditional Chinese Wellness Wisdom.<br/>Through Baduanjin​ (Eight-Broken Pieces of Brocade) instruction, wellness seminars, community events, and corporate health programs, we foster holistic well-being and active lifestyles.',
		
		item1Title:'Community Wellness',
		item1SonTitle:'A Community Hub for Holistic Wellness',
		item1Text:'As the cornerstone of neighborhood health initiatives, we serve residents of all ages. We bring complimentary wellness and fitness classes right to your doorstep, fostering a new culture of healthy living within the community.',
		
		item2Title:'Workplace Wellness',
		item2SonTitle:'Light Wellness Solutions for Professionals',
		item2Text:'Addressing common workplace sub-health issues, we offer light, fragmented workouts designed to fit into busy schedules. Our programs target sedentary fatigue, neck and shoulder stiffness, mental burnout, and lack of focus—delivering practical relief right at the office.',
		
		item3Title:'School Wellness',
		item3SonTitle:'A Platform for Youth Development',
		item3Text:'Designed for K-12 and university communities, this program uses Baduanjin​ to build physical strength, alleviate academic stress, and cultivate inner character. We integrate physical education with aesthetic education to create a distinctive campus wellness initiative.',
		
		item4Title:'Silver',
		item4SonTitle:'Scientific Wellness System for Seniors',
		item4Text:'Tailored to the physiological needs of older adults, this program offers gentle, safe, and evidence-based exercises. It supports chronic disease management, boosts immunity, promotes longevity, and enriches the golden years with purposeful activity.',
	},
	influence:{
		sonTitle:'Huaxin Culture actively drives community welfare and social responsibility.',
		
		
		item1Title:'Golden Years Digital Literacy Initiative',
		item1Text:'As a philanthropic partner, Huaxin Culture provides long-term support to the Golden Years Foundation for its digital literacy programs. We focus on building the "Digital Buddy" volunteer network, funding volunteer development and community engagement to foster digital inclusion and active aging.',
		
		item2Title:'Community Charity Donation Program',
		item2Text:'<div>Our Long-term Commitments:</div><div class="yxlTextList">HWA (Handicaps Welfare Association)</div><div class="yxlTextList">SACS (Singapore Anglican Community Services)</div><div class="yxlTextList">SAMH (St. Andrew\'s Mission Hospital)</div><div>We adhere to a strict policy of monthly recurring charitable donations to ensure sustained community support.</div>',
		
		item3Title:'Youth Volunteer Development Program',
		item3Text:'Cultivating Digital Mentors, Community Volunteers, Young Philanthropy Leaders, and Welfare Ambassadors.'
	},
	news:{
		allNews:'All news'
	},
	contact:{
		sonTitle:'Looking forward to hearing from you',
		officeAddress:'Office address:',
		contactInformation:'Contact information:',
		email:'E-mail',
		webSite:'Official website:'
	}
}
